import { useContext } from 'react'
import LocaleContext from 'common/contexts/locale'
import makeTranslate from 'common/utils/make-translate'

function useTranslate() {
  const translations = useContext(LocaleContext)
  return makeTranslate(translations)
}

export default useTranslate
